import type { FaireProductEntity } from "../../entity_types/product";

export const p_er2m9n5gwr: FaireProductEntity = {
  token: "p_er2m9n5gwr",
  type: "product",
  name: "Blue Chalcedony Tiny Fairy Hearts",
  brandToken: "b_ciwhgi8nfq",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/af137b9107dafc1552cdf554710a9308fb0c10995738999a803046f292e22ae5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/76827497140a15b17f452608d1241ad47ab3ef212fe317250133a4a9adf7a5cb.jpeg",
    "https://cdn.faire.com/fastly/fb732ebefb38c9ee7037dc100b3b0cb29c4a6b0abf8db6b4e95c7d6d7e1ec475.jpeg",
  ],
  priceDollars: 4.16,
  description:
    "💙 Blue Chalcedony Tiny Fairy Hearts 💙\n\nThese blue chalcedony tiny hearts are polished smooth and shaped to fit comfortably in the palm or on display trays. Featuring soft sky-blue tones with subtle translucence, each heart highlights chalcedony’s calming, gentle presence. Their small size makes them perfect for gifts, crystal collections, or touch-and-feel displays.\n\nProduct Details\n• Polished blue chalcedony tiny hearts\n• Soft, translucent sky-blue coloration\n• Small, pocket-friendly size\n• Each heart is unique in tone and internal pattern\n• Ideal for gift assortments, crystal collections, and display trays\n• Natural stone — variations are expected and embraced\n\nBlue chalcedony is often associated with calm communication, emotional balance, and soothing energy, making these hearts a gentle and approachable choice for customers.\n\nA charming addition for shops offering chalcedony hearts, tiny crystal palm stones, and thoughtfully curated wholesale pieces with lasting appeal. 💙",
  tags: [],
  msrpDollars: 8.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:33.252Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
